
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/intercityxpress",
      function () {
        return require("private-next-pages/case-study/intercityxpress.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/intercityxpress"])
      });
    }
  